import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_DOCTOR_APPOINTMENTS } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

// POST: Join Doctor Appointment
export const joinDoctorAppointmentReducer = createAsyncThunk(
  ACTION_DOCTOR_APPOINTMENTS.join_appointment,
  async ({ appointmentId }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.joinDoctorAppointment}/${appointmentId}/join`
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Joined appointment successfully");
        return response.data.data || response.data;
      } else {
        const msg =
          response?.data?.message || "Failed to join doctor appointment.";
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error joining appointment:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while joining appointment.";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
